export default __webpack_public_path__ + "static/media/banner.c40dde6e.jpg";